const columns: TableColumn[] = [
  {
    Header: `ID`,
    accessor: `id`,
    dbKey: `id`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Name`,
    accessor: `name`,
    dbKey: `name`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true,
    canHide: false
  },
  {
    Header: `Email`,
    accessor: `email`,
    dbKey: `email`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Phone`,
    accessor: `phone`,
    dbKey: `phone`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `City`,
    accessor: `city`,
    dbKey: `city`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true,
    defaultHidden: true,
  },
  {
    Header: `State`,
    accessor: `state`,
    dbKey: `state`,
    defaultHidden: true,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Country`,
    accessor: `country`,
    dbKey: `country`,
    defaultHidden: true,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Source`,
    accessor: `source`,
    dbKey: `source`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Enquiry Type`,
    accessor: `enquiry_type`,
    dbKey: `enquiry_type`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Property Address`,
    accessor: `property_address`,
    dbKey: `property_address`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Property Price`,
    accessor: `property_price`,
    dbKey: `property_price`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Property Ref #`,
    accessor: `property_reference_number`,
    dbKey: `property_reference_number`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Comments`,
    accessor: `comments`,
    dbKey: `comments`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Portal URL`,
    accessor: `portalurl`,
    dbKey: `portalurl`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Conversation History`,
    accessor: `conversation_history`,
    dbKey: `conversation_history`,
    defaultHidden: true,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Tags`,
    accessor: `tags`,
    dbKey: `tags`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Created`,
    accessor: `createdAt`,
    dbKey: `createdAt`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Updated`,
    accessor: `updatedAt`,
    dbKey: `updatedAt`,
    isString: false,
    isNumeric: false,
    isDate: true,
    isBool: false,
    isSortable: true
  }
];

export default columns;
